/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: Testimonial
 * Page name: Testimonial page
 * Page Description: This is the Testimonial page of the website of Ekathva Innovations.
 */
import "bootstrap/dist/css/bootstrap.min.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import { Card, Col, Row, Image } from "react-bootstrap";
import React, { useEffect } from "react";
import Aos from "aos";
import { getImage } from "utils/imageUtilsTestimonial";

import { ReactComponent as Comma } from "assets/images/Testimonial/Invertedcomma.svg";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

function Testi(props) {
  useEffect(() => {
    Aos.init({});
  }, []);

  const { data } = props;

  return (
    <div>
      <div>
        <Carousel
          autoPlay={true}
          responsive={responsive}
          infinite={true}
          autoPlaySpeed={2500}
        >
          {/* Slice to get only the last 3 testimonials */}
          {data.data.slice(-6).map((t) => {
            const imageSrc = getImage(t.img);
            return (
              <Row key={t.name}>
                <Col>
                  <div className="homepagetestimonial_carouselspacing">
                    <div className="homepagetestimonial_padding">
                      <Card className="homepagetestimonial_cardsize">
                        <Row className="homepagetestimonial_imagestyle">
                          <Col md={2}></Col>
                          <Col md={6}>
                            <Comma
                              className="homepagetestimonial_commasize svgcolor"
                              roundedCircle
                            />
                          </Col>
                          <Col md={4}></Col>
                        </Row>

                        <div
                          data-aos="fade-up"
                          className="homepagetestimonial_contentpadding"
                        >
                          <Row>
                            <Col md={4}></Col>
                            <Col md={4}>
                              <Image
                                variant="top"
                                src={imageSrc}
                                alt="Image"
                                className="homepagetestimonial_imagesizing"
                                roundedCircle
                              />
                            </Col>
                            <Col md={4}></Col>
                          </Row>
                          <p className="homepagetestimonial_contentfont">
                            <strong>
                              <br />
                              {t.testimonial}
                            </strong>
                            <br />
                            <br />
                            <span className="it_ssnamecolor">{t.name},</span>
                            <span className="aboutus_fontbold">
                              <br />
                              {t.company},
                            </span>
                            <span>
                              <br />
                              {t.place}
                            </span>
                          </p>
                        </div>
                      </Card>
                    </div>
                  </div>
                </Col>
              </Row>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
}

export default Testi;
